import { render } from "./AssetTypeList.vue?vue&type=template&id=90e6f68c&scoped=true"
import script from "./AssetTypeList.vue?vue&type=script&lang=js"
export * from "./AssetTypeList.vue?vue&type=script&lang=js"

import "./AssetTypeList.vue?vue&type=style&index=0&id=90e6f68c&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e6f68c"]])

export default __exports__